import type { WarpGrepProvider } from '../../providers/types.js';

export async function toolGlob(
  provider: WarpGrepProvider,
  args: { pattern: string; path?: string }
): Promise<string> {
  const res = await provider.glob(args);

  if (res.error) {
    return res.error;
  }

  if (!res.files.length) {
    return 'no matches';
  }

  // Match training output format exactly
  const header = `Found ${res.totalFound} file(s) matching "${args.pattern}" within ${res.searchDir}, sorted by modification time (newest first):`;
  const body = res.files.join('\n');
  const truncated = res.totalFound > res.files.length
    ? `\n[${res.totalFound - res.files.length} files truncated]`
    : '';
  return `${header}\n---\n${body}\n---${truncated}`;
}
